export type Labels = Record<string, string>;

/**
 * Special Prometheus label that represents the metric name.
 * @see https://prometheus.io/docs/prometheus/latest/configuration/template_reference/#data-structures
 */
export const METRIC_NAME_LABEL_KEY = '__name__';
